module.exports = __webpack_public_path__ + "static/media/generateqr.0f133ae6.svg";